import type { SkillImage } from "@/types/data";

// Re-export type for convenience
export type { SkillImage } from "@/types/data";

export const skillImagesData: SkillImage[] = [
  // Plumbing
  {
    id: "1",
    filename: "plumbing.jpg",
    path: "/skill-images/Plumbing/plumbing.jpg",
    title: "Plumbing",
    category: "Plumbing",
    status: "available",
    description:
      "Plumbing is the installation and maintenance of systems that deliver water and remove waste from a building.",
  },

  // Electrical
  {
    id: "2",
    filename: "tv.jpg",
    path: "/skill-images/Electrical/tv.jpg",
    title: "Electrical",
    category: "Electrical",
    status: "available",
    description:
      "Electrical is the installation and maintenance of systems that deliver electricity to a building.",
  },

  // Carpentry
  {
    id: "3",
    filename: "ladder.jpg",
    path: "/skill-images/Carpentry/ladder.jpg",
    title: "Carpentry",
    category: "Carpentry",
    status: "available",
    description:
      "Carpentry involves the construction, installation, and repair of wooden structures, furniture, and fixtures.",
  },

  // Painting
  {
    id: "4",
    filename: "painting.jpg",
    path: "/skill-images/Painting/painting.jpg",
    title: "Painting",
    category: "Painting",
    status: "available",
    description:
      "Painting involves applying paint, varnish, and other finishes to interior and exterior surfaces for protection and aesthetics.",
  },

  // Roofing
  {
    id: "5",
    filename: "roofing.jpg",
    path: "/skill-images/Roofing/roofing.jpg",
    title: "Roofing",
    category: "Roofing",
    status: "available",
    description:
      "Roofing involves the installation, repair, and maintenance of roof structures to protect buildings from weather elements.",
  },

  // Flooring
  {
    id: "6",
    filename: "flooring.jpg",
    path: "/skill-images/Flooring/flooring.jpg",
    title: "Flooring",
    category: "Flooring",
    status: "available",
    description:
      "Flooring involves the installation and repair of various floor coverings including timber, tiles, carpet, and vinyl.",
  },
  {
    id: "7",
    filename: "flooring-2.jpg",
    path: "/skill-images/Flooring/flooring-2.jpg",
    title: "Flooring",
    category: "Flooring",
    status: "available",
    description:
      "Flooring involves the installation and repair of various floor coverings including timber, tiles, carpet, and vinyl.",
  },

  // Tiling
  {
    id: "8",
    filename: "tiling.jpg",
    path: "/skill-images/Tiling/tiling.jpg",
    title: "Tiling",
    category: "Tiling",
    status: "available",
    description:
      "Tiling involves the installation and repair of ceramic, porcelain, and stone tiles for floors, walls, and wet areas.",
  },

  // Landscaping
  {
    id: "9",
    filename: "landscaping.jpg",
    path: "/skill-images/Landscaping/landscaping.jpg",
    title: "Landscaping",
    category: "Landscaping",
    status: "available",
    description:
      "Landscaping involves the design, installation, and maintenance of outdoor spaces including gardens, lawns, and hardscaping.",
  },

  // HVAC
  {
    id: "10",
    filename: "air-conditioning.jpg",
    path: "/skill-images/HVAC/air-conditioning.jpg",
    title: "HVAC",
    category: "HVAC",
    status: "available",
    description:
      "HVAC (Heating, Ventilation, and Air Conditioning) involves the installation and maintenance of climate control systems.",
  },

  // Masonry
  {
    id: "11",
    filename: "masonry.jpg",
    path: "/skill-images/Masonry/masonry.jpg",
    title: "Masonry",
    category: "Masonry",
    status: "available",
    description:
      "Masonry involves the construction and repair of structures using bricks, stones, concrete blocks, and mortar.",
  },

  // Glazing
  {
    id: "12",
    filename: "glazing.jpg",
    path: "/skill-images/Glazing/glazing.jpg",
    title: "Glazing",
    category: "Glazing",
    status: "available",
    description:
      "Glazing involves the installation and repair of glass windows, doors, and other glass fixtures.",
  },

  // Handyman Services
  {
    id: "13",
    filename: "handyman.jpg",
    path: "/skill-images/Handyman Services/handyman.jpg",
    title: "Handyman Services",
    category: "Handyman Services",
    status: "available",
    description:
      "Handyman services cover a wide range of general repairs, maintenance, and small installation tasks around the home.",
  },

  // Solar Installation
  {
    id: "14",
    filename: "solar.jpg",
    path: "/skill-images/Solar Installation/solar.jpg",
    title: "Solar Installation",
    category: "Solar Installation",
    status: "available",
    description:
      "Solar installation involves the design, installation, and maintenance of solar panel systems for renewable energy generation.",
  },

  // Pool Maintenance
  {
    id: "15",
    filename: "pool-maintenance.jpg",
    path: "/skill-images/Pool Maintenance/pool-maintenance.jpg",
    title: "Pool Maintenance",
    category: "Pool Maintenance",
    status: "available",
    description:
      "Pool maintenance involves cleaning, chemical balancing, equipment repair, and general upkeep of swimming pools.",
  },

  // Fencing
  {
    id: "16",
    filename: "fencing.jpg",
    path: "/skill-images/Fencing/fencing.jpg",
    title: "Fencing",
    category: "Fencing",
    status: "available",
    description:
      "Fencing involves the installation and repair of boundary fences using materials like timber, metal, and composite.",
  },

  // Concreting
  {
    id: "17",
    filename: "concreting.jpg",
    path: "/skill-images/Concreting/concreting.jpg",
    title: "Concreting",
    category: "Concreting",
    status: "available",
    description:
      "Concreting involves the pouring, finishing, and repair of concrete surfaces for driveways, paths, and foundations.",
  },

  // Bricklaying
  {
    id: "18",
    filename: "bricklaying.jpg",
    path: "/skill-images/Bricklaying/bricklaying.jpg",
    title: "Bricklaying",
    category: "Bricklaying",
    status: "available",
    description:
      "Bricklaying involves the construction and repair of brick structures including walls, chimneys, and facades.",
  },

  // Demolition
  {
    id: "19",
    filename: "demolish.jpg",
    path: "/skill-images/Demolition/demolish.jpg",
    title: "Demolition",
    category: "Demolition",
    status: "available",
    description:
      "Demolition involves the safe removal and disposal of structures, walls, and building components.",
  },

  // Insulation
  {
    id: "20",
    filename: "insulation.jpg",
    path: "/skill-images/Insulation/insulation.jpg",
    title: "Insulation",
    category: "Insulation",
    status: "available",
    description:
      "Insulation involves the installation of thermal and acoustic insulation materials in walls, roofs, and floors.",
  },

  // Kitchen Installation
  {
    id: "21",
    filename: "kitchen-installation.jpg",
    path: "/skill-images/Kitchen Installation/kitchen-installation.jpg",
    title: "Kitchen Installation",
    category: "Kitchen Installation",
    status: "available",
    description:
      "Kitchen installation involves the design, fitting, and installation of kitchen cabinets, benchtops, and fixtures.",
  },

  // Bathroom Renovation
  {
    id: "22",
    filename: "bathroom-renovation.jpg",
    path: "/skill-images/Bathroom Renovation/bathroom-renovation.jpg",
    title: "Bathroom Renovation",
    category: "Bathroom Renovation",
    status: "available",
    description:
      "Bathroom renovation involves the complete redesign and installation of bathroom fixtures, tiling, and plumbing.",
  },

  // Decking
  {
    id: "23",
    filename: "decking.jpg",
    path: "/skill-images/Decking/decking.jpg",
    title: "Decking",
    category: "Decking",
    status: "available",
    description:
      "Decking involves the construction and repair of outdoor deck structures using timber or composite materials.",
  },

  // Garage Doors
  {
    id: "24",
    filename: "garage.jpg",
    path: "/skill-images/Garage Doors/garage.jpg",
    title: "Garage Doors",
    category: "Garage Doors",
    status: "available",
    description:
      "Garage door services include installation, repair, and maintenance of automatic and manual garage door systems.",
  },

  // Security Systems
  {
    id: "25",
    filename: "security-systems.jpg",
    path: "/skill-images/Security Systems/security-systems.jpg",
    title: "Security Systems",
    category: "Security Systems",
    status: "available",
    description:
      "Security systems installation includes alarms, cameras, access control, and monitoring systems for home and business security.",
  },

  // Air Conditioning
  {
    id: "26",
    filename: "air-conditioning.jpg",
    path: "/skill-images/Air Conditioning/air-conditioning.jpg",
    title: "Air Conditioning",
    category: "Air Conditioning",
    status: "available",
    description:
      "Air conditioning services include installation, repair, and maintenance of split systems, ducted systems, and evaporative coolers.",
  },
];

// Helper function to get images by category
export function getImagesByCategory(category: string): SkillImage[] {
  return skillImagesData.filter((img) => img.category === category);
}

// Helper function to get available images only
export function getAvailableImages(): SkillImage[] {
  return skillImagesData.filter((img) => img.status === "available");
}

// Helper function to get missing images
export function getMissingImages(): SkillImage[] {
  return skillImagesData.filter((img) => img.status === "missing");
}

// Helper function to get image path by trade name
export function getImagePathByTrade(trade: string): string | null {
  const image = skillImagesData.find((img) => img.category === trade);
  return image?.path || null;
}
